<template>
    <div id="listInvoice">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>       

        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="container-fluid xyz">
                    <div class="page-name">Invoice Detail
                        <!-- <router-link href="javascript:void(0)" class="btn btn-success waves-effect pull-right" v-bind:to="'/invoice/list'"> 
                            Back
                        </router-link> -->
                        <button type="button" class="btn btn-success waves-effect pull-right" v-on:click="backBtn()" > 
                            <i class="hi-icon icon-flback"> </i> Back
                        </button>
                        <button type="button" class="btn btn-success waves-effect pull-right" v-on:click="downloadPdf()" > 
                            <i class="hi-icon icon-flexport"> </i> Download
                        </button>
                        <button type="button" class="btn btn-success waves-effect pull-right" v-on:click="print()" > 
                            <i class="hi-icon icon-flexport"> </i> Print
                        </button>
                        
                    </div>
                    <div class="admin-page-content">
                        <section class="internal-container">
                            <div class="container">
                                <div class="invoice-view-table" id="print_content_default">
                                    
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="col-md-12">
                    <div class="error-template">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>


<script>

    import Vue from 'vue';
    
    
    import {commonMixins} from '../../mixins/commonMixins';
    
    
    export default {
        name: "listRate",
        metaInfo: {
            // title will be injected into parent titleTemplate
            title: "Customer Invoice Preview | " +process.env.COPYRIGHT_NAME
        },
        mixins:[commonMixins],
        data: () => ({
            invoiceArr:[],
            loading:false,
            permissions:[],
            cantAccessPage:"",
            canAdd:false,
            canUpdate:false,
            invoiceId : 0,
            path:"",

        }),
        watch:{
            permissions: function(permission){
                var self = this;
                permission.forEach(function (permissions) {
                    if(permissions.name == 'view_invoice') {
                        self.cantAccessPage = true;
                    }
                });
                if(self.cantAccessPage == ''){
                    self.cantAccessPage = false;
                }
            }
        },
        mounted: function() {

            var self = this;
            self.invoiceId = this.$route.params.id;

            //load list of card rate            
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/default-invoice/preview",
                type: "GET",
                data: {
                    invoice_id:self.invoiceId,                    
                },
                crossDomain: true,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    setTimeout(function(){
                        self.loading = false ;
                        $("#print_content_default").html("");
                        $("#print_content_default").html(data.view);
                    },500);
                    
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,false,'default-invoice-preview');
                }
            });
            self.getPermissions();
            self.path = process.env.API +  "/images/logo.png";

        },
        methods: {
            backBtn(){
                var self = this;
                
                if(this.$route.query.paymentId != undefined) {
                    self.$router.push("/invoice/list/?paymentId="+this.$route.query.paymentId + "&flag=paymentlist");
                } else {
                    self.$router.push("/invoice/list");
                }
                
            },
            downloadPdf() {
                var self = this;
                self.loading = true ;
                $.ajax({
                    url: process.env.ROOT_API + "/invoice/pdf",
                    type: "POST",
                    data: {
                        invoice_id:self.invoiceId,
                        invoice_type:"",
                        invoice_origin:"system"
                    },
                    headers: this.ajxHeaders,
                    dataType: 'json',
                    success: function (data) {
                        self.loading = false ;
                        if (data.status == 'success'){
                            var link = document.createElement('a');
                            document.body.appendChild(link);
                            link.href = data.content;
                            link.download = '';
                            link.target = "_blank";
                            link.click();
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'download-default-invoice');
                    }
                });

            },
            print() {
                var self = this;
                self.loading = true;
                var content = document.getElementById('print_content_default').innerHTML;
                var a = window.open(content, '_blank');                
                a.document.write(content); 
                a.document.close();
                self.loading = false;
                a.print();
                a.close();
            }
        },
    };
</script>
<style scoped="">
    table, th, td {
        border: none;
    }
    </style>



// WEBPACK FOOTER //
// src/components/invoice/InvoiceView.vue